/**
 * @fileoverview Decisão PURA da variante de copy do AccountGateScreen.
 *
 * Extraída do componente pra ser testável sem montar a tela inteira (que puxa
 * pairing/i18n/Norigin). Três variantes, uma precedência:
 *
 *  - `reconnect`: o aparelho JÁ vinculou uma conta Swipe (marcador durável
 *    `iptv:swipe-linked`) e a sessão caiu. Copy "sua sessão caiu, reconecte".
 *  - `link`: base instalada — logado só no Xtream (`isAuthed`), sem conta Swipe
 *    e SEM ter vinculado antes. Copy "vincule sua conta".
 *  - `entry`: 1ª entrada / boot sem nada. Copy "comece grátis".
 *
 * `wasLinked` é UX-ONLY: NUNCA é identidade nem autorização. Aqui ele só escolhe
 * a copy; a presença de sessão (`hasSwipeSession`) continua sendo o que de fato
 * libera o app (decidido no RootRoute, não aqui).
 */

export type GateVariant = 'entry' | 'link' | 'reconnect'

export function resolveGateVariant(args: {
  isAuthed: boolean
  hasSwipeSession: boolean
  wasLinked: boolean
}): GateVariant {
  // Com sessão Swipe o usuário nem chega ao gate; os guards `&& !hasSwipeSession`
  // deixam a função correta mesmo assim (defensivo).
  if (args.wasLinked && !args.hasSwipeSession) return 'reconnect'
  if (args.isAuthed && !args.hasSwipeSession) return 'link'
  return 'entry'
}
